import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-1345e30b"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  role: "img",
  "aria-hidden": "true",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 14 15"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M7.94711 12.0096\n   V11.8221\n   H7.75961\n   H6.69231\n   H6.50481\n   V12.0096\n   V13.2452\n   H2.25481\n   V1.87981\n   H6.50481\n   V3.11538\n   V3.30288\n   H6.69231\n   H7.75961\n   H7.94711\n   V3.11538\n   V0.625\n   V0.4375\n   H7.75961\n   H1\n   H0.8125\n   V0.625\n   V14.5\n   V14.6875\n   H1\n   H7.75961\n   H7.94711\n   V14.5\n   V12.0096\n   Z",
    "stroke-width": "0.375"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M12.7405 8.28366\n   H12.928\n   V8.09616\n   V7.02885\n   V6.84135\n   H12.7405\n   H8.65874\n   V5.74097\n   V5.40974\n   L8.37474 5.5802\n   L5.34003 7.40174\n   L5.07219 7.56251\n   L5.34003 7.72327\n   L8.37474 9.54481\n   L8.65874 9.71527\n   V9.38404\n   V8.28366\n   H12.7405\n   Z",
    "stroke-width": "0.375"
  })
], -1))


export default /*#__PURE__*/_defineComponent({
  __name: 'SignOutButton',
  emits: ['click'],
  setup(__props, { emit: __emit }) {


const emit = __emit;

const handleClick = () => {
  emit('click');
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: "signOutButton",
    type: "button",
    onClick: handleClick
  }, [
    _hoisted_1,
    _createTextVNode(" " + _toDisplayString(_ctx.$t('Sign out')), 1)
  ]))
}
}

})